/**
 * Implements the Fisher-Yates shuffle for arrays. See:
 * https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
 */
function shuffleArray<T>(array: Array<T>): Array<T> {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function maskPhone(phone: string): string {
  const x = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  // @ts-expect-error TODO: fix null safety
  return !x[2] ? x[1] : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ''}`;
}

function unmaskPhone(phone: string): string {
  return phone.replace(/\s|\(|\)|-/g, '');
}

function formatZip(value: string | null): string {
  const input = value || '';
  if (input.search(/^\d{9}$/) === 0) {
    return `${input.slice(0, 5)}-${input.slice(5, 9)}`;
  }
  return input;
}

export { shuffleArray, maskPhone, unmaskPhone, formatZip };
